"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "tenant",
              "theme"
            ]);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Footer-Public.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_attrs0 = {
        "class": "d-md-block d-none"
      },
    marko_attrs1 = {
        "class": "position-fixed bottom-0 px-5 py-3"
      },
    marko_attrs2 = {
        "class": "list-inline m-0 d-inline-flex align-items-center"
      },
    marko_attrs3 = {
        "class": "position-fixed bottom-0 right-0 px-5 py-3"
      },
    marko_attrs4 = {
        "class": "list-inline m-0 d-inline-flex align-items-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("cfb852"),
    marko_node0 = marko_createElement("li", {
        "class": "px-1"
      }, "11", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("|"),
    marko_node1 = marko_createElement("li", {
        "class": "px-1"
      }, "15", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("|");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", marko_attrs1, "1", component);

  out.be("ul", marko_attrs2, "2", component);

  if (!state.tenant) {
    out.e("li", null, "3", component, 1)
      .e("img", {
          src: ("/images/favicon/logo-small" + (state.theme.mode == "dark" ? "-white" : "")) + ".png",
          height: "30",
          "class": "px-3"
        }, "4", component, 0);
  }

  out.e("li", null, "5", component, 4)
    .t("Copyright © ")
    .t((new Date()).getFullYear(), component)
    .t(" ")
    .t(state.tenant ? state.tenant.name : "Multipple, Inc", component);

  out.ee();

  out.ee();

  out.be("div", marko_attrs3, "6", component);

  out.be("ul", marko_attrs4, "7", component);

  out.be("li", null, "8", component);

  route_link_tag({
      renderBody: function(out) {
        Locale_tag({
            text: "Privacy Policy",
            class: "theme-color font-medium-1"
          }, out, __component, "10");
      }
    }, out, __component, "9");

  out.ee();

  out.n(marko_node0, component);

  out.be("li", null, "12", component);

  route_link_tag({
      renderBody: function(out) {
        Locale_tag({
            text: "Cookie Policy",
            class: "theme-color font-medium-1"
          }, out, __component, "14");
      }
    }, out, __component, "13");

  out.ee();

  out.n(marko_node1, component);

  out.be("li", null, "16", component);

  route_link_tag({
      renderBody: function(out) {
        Locale_tag({
            text: "Terms",
            class: "theme-color font-medium-1"
          }, out, __component, "18");
      }
    }, out, __component, "17");

  out.ee();

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
